module.exports = __webpack_public_path__ + "media/images/icon_pop_close-45ab664c31da207b139fd6b589df0dee.png";